module.exports = __webpack_public_path__ + "img/merit_icon4.fb0653c5.png";